<div *ngIf="user" [attr.role]="isGranted(permissionsConst.User_Detail) ? 'button' : ''" class="d-flex align-items-center justify-content-between" (click)="goOnUserDetail()">
    <span>
        <em class="fas fa-user mr-2" *ngIf="withEntityTypeIcon"></em>

        <span class="badge badge-dark mr-2" *ngIf="withEntityTypeBadge && user.entityType">{{ user.entityType | localize }}</span>

        <span>{{ user.fullName }}</span>
    </span>
</div>
